var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu32X32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24/Menu/Menu burger 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6654 8C27.6654 8.55228 27.2176 9 26.6654 9L5.33203 9C4.77975 9 4.33203 8.55228 4.33203 8C4.33203 7.44772 4.77975 7 5.33203 7L26.6654 7C27.2176 7 27.6654 7.44772 27.6654 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6654 16C27.6654 16.5523 27.2176 17 26.6654 17L5.33203 17C4.77975 17 4.33203 16.5523 4.33203 16C4.33203 15.4477 4.77975 15 5.33203 15L26.6654 15C27.2176 15 27.6654 15.4477 27.6654 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6654 24C27.6654 24.5523 27.2176 25 26.6654 25L17.332 25C16.7797 25 16.332 24.5523 16.332 24C16.332 23.4477 16.7797 23 17.332 23L26.6654 23C27.2176 23 27.6654 23.4477 27.6654 24Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu32X32);
export default __webpack_public_path__ + "static/media/MENU_32X32.deeba3702a54685fda4a7bdbf65c0a40.svg";
export { ForwardRef as ReactComponent };